( function ( $ ) {

	MP.page_desc_toggle_view = function(){

		var $btn_tog = $('.btn-toggle_view');

		if ( ! $btn_tog.length ) return;

		$btn_tog.html(
			'<sapn class="l-flex f-c">' + 
				$btn_tog.text() +
				'<i class="icon-plus"></i>' +
			'</span>'
		);

		$btn_tog.on( 'click' , function(){

			var $it = $(this);
			var $el = $it.parent().find('.element-toggle_view');
			
			var effect = ( $el.css('display') === 'none' ) ? 'Down' : 'Up';

			$el[ 'slide' + effect ](200);

		});

	};

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/l-page-desc.js